var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTodayIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9C0 4.02944 4.02944 0 9 0H25C29.9706 0 34 4.02944 34 9V25C34 29.9706 29.9706 34 25 34H9C4.02944 34 0 29.9706 0 25V9Z",
    fill: "#F1F0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 11.75H21.5C22.5355 11.75 23.375 12.5895 23.375 13.625V21.875C23.375 22.9105 22.5355 23.75 21.5 23.75H12.5C11.4645 23.75 10.625 22.9105 10.625 21.875V13.625C10.625 12.5895 11.4645 11.75 12.5 11.75Z",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#6860EE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.625 10.25V13.25M20.375 10.25V13.25M10.625 15.5H23.375",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#6860EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTodayIcon);
export default __webpack_public_path__ + "static/media/today-icon.1f4f94012e3d172ab430ed7b16961fba.svg";
export { ForwardRef as ReactComponent };